import {
  Grid,
  Typography,
  TextField,
  Button,
  MenuItem,
  Link,
} from "@mui/material";
import colors from "../../../../colors";
import { useSelector, useDispatch } from "react-redux";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import { makeStyles } from "@mui/styles";
import {
  selectDigitalbState,
  setMessage,
  setSuccess,
} from "../../../../../features/digitalb/digitalbSlice";
import {
  selectMyContractsState,
  setShouldFillFields,
} from "../../../../../features/myContracts/myContractsSlice";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { texts } from "../../../../general/texts";
import { useEffect } from "react";
import { useState } from "react";
import DigitalbOTPCodeView from "./DigitalbOTPCodeView";
import { setGeneralMessage } from "../../../../../features/global/globalDataSlice";

const DigitalbOTT = (props) => {
  const dispatch = useDispatch();
  const digitalbSliceState = useSelector(selectDigitalbState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [otp, setOtp] = useState("");

  const handleCloseModal = () => {
    dispatch(setMessage(""));
    dispatch(setSuccess(""));
    setIsOpen(false);
  };

  const [state, setState] = useState({
    token: props.globalDataSliceState.token,
    productCode: "",
    ottUsername: "",
  });

  const handleTextFieldChange = (prop) => (e) => {
    setState({
      ...state,
      [prop]: e.target.value,
    });
  };

  const handleCreateDigitalbAccountButtonClick = () => {
    dispatch(
      sendGeneralRequest({
        request: { token: state.token },
        baseUrlKey: "services",
        endpoint: "DGA/StartOTTActivation",
      })
    );
  };

  useEffect(() => {
    if (digitalbSliceState.success === true) {
      dispatch(
        setGeneralMessage({
          type: "success",
          message: digitalbSliceState.message,
        })
      );
      setIsOpen(true);
    } else if (digitalbSliceState.success === false) {
      dispatch(
        setGeneralMessage({
          type: "error",
          message: digitalbSliceState.message,
        })
      );
    } else if (digitalbSliceState.confirmData.success === true) {
      dispatch(
        setGeneralMessage({
          type: "success",
          message: digitalbSliceState.confirmData.message,
        })
      );
    } else if (digitalbSliceState.confirmData.success === false) {
      dispatch(
        setGeneralMessage({
          type: "error",
          message: digitalbSliceState.confirmData.message,
        })
      );
    }
  }, [
    digitalbSliceState.success,
    digitalbSliceState.message,
    digitalbSliceState.confirmData.success,
    digitalbSliceState.confirmData.message,
    dispatch,
  ]);

  const handleConfirmOtpCodeButtonClick = () => {
    dispatch(
      sendGeneralRequest({
        request: { token: state.token, dgaVerificationCode: otp },
        baseUrlKey: "services",
        endpoint: "DGA/ConfirmOTTActivation",
      })
    );
  };

  // useEffect(() => {
  //   dispatch(
  //     sendGeneralRequest({
  //       request: { token: state.token },
  //       baseUrlKey: "services",
  //       endpoint: "DGA/GetProductsOTT",
  //     })
  //   );
  // }, [dispatch, state.token]);

  useEffect(() => {
    if (myContractsSliceState.shouldFillFields) {
      setState({
        ...state,
        sc: props.selectedContractInfo.contract,
      });
      dispatch(setShouldFillFields(false));
    }
  }, [
    myContractsSliceState.shouldFillFields,
    dispatch,
    props.selectedContractInfo.contract,
    state,
  ]);

  const useStyles = makeStyles({
    mainGrid: {
      padding: "5%",
      paddingTop: "3%",
    },
    utilityName: {
      color: props.utilityInfo.Color,
      fontSize: "1.5rem",
      fontFamily: "GerberaBold",
      paddingTop: "3%",
      paddingLeft: "2%",
    },
    headerBox: {
      backgroundColor: colors.cyan,
      borderRadius: "100%",
      width: "70px",
      height: "70px",
    },
    fieldTitle: {
      color: colors.darkBlue,
      fontSize: "1.2rem",
      fontFamily: "GerberaBold",
      textAlign: "left",
    },
    button: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.gradientOrange,
      fontFamily: "GerberaBold",
    },
    buttonGrid: {
      marginTop: 10,
      paddingBottom: 0,
    },
    image: {
      width: "50%",
    },
    textField: {
      width: "100%",
    },
    buttonCreateAccount: {
      width: "100%",
      color: colors.darkBlue,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.white,
      fontFamily: "GerberaBold",
      "&:hover": { background: colors.white },
      border: "2px solid #365472",
    },
  });

  const classes = useStyles();
  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
      <Grid container item md={2} xs={2} mt={2}>
        <Link
          component={"button"}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosNewIcon color="warning" />
        </Link>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.headerBox}
        >
          <img
            src={
              props.utilityInfo.Images.filter(
                (image) => image.color === 1 && image.size === 1
              )[0].imagePath
            }
            alt="Utility Logo"
            className={classes.image}
          />
        </Grid>
        <Typography className={classes.utilityName}>
          {props.utilityInfo.PublicName + "OTT"}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12} mt={"5%"}>
        <Typography className={classes.fieldTitle}>
          {texts["prompt-choose-product"]}
        </Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField
          value={state.productCode}
          label={texts["dialog-product"]}
          select
          color="warning"
          size="small"
          onChange={handleTextFieldChange("productCode")}
          className={classes.textField}
        >
          {props.digitalbSliceState.extraData.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              {option.name} {option.price} {texts["currency"]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>{texts["OTT-user"]}</Typography>
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField
          onChange={handleTextFieldChange("ottUsername")}
          color="warning"
          size="small"
          placeholder={"Përdoruesi"}
          className={classes.textField}
        />
      </Grid>
      <Grid item md={12} xs={12} className={classes.buttonGrid}>
        <Button
          disabled={digitalbSliceState.isLoading ? true : false}
          onClick={() =>
            dispatch(
              sendGeneralRequest({
                request: state,
                baseUrlKey: "services",
                endpoint: "DGA/StartTransactionOTT",
              })
            )
          }
          className={classes.button}
        >
          {texts["title-search"]}
        </Button>
      </Grid>
      <Grid item md={12} xs={12} className={classes.buttonGrid}>
        <Button
          onClick={() => handleCreateDigitalbAccountButtonClick()}
          className={classes.buttonCreateAccount}
        >
          {texts["prompt-no-account-create-ott"]}
        </Button>
      </Grid>
      <DigitalbOTPCodeView
        isOpen={isOpen}
        handleCloseModal={handleCloseModal}
        otp={otp}
        setOtp={setOtp}
        handleConfirmOtpCodeButtonClick={handleConfirmOtpCodeButtonClick}
        classes={classes}
      />
    </Grid>
  );
};

export default DigitalbOTT;
